import axios from "axios";
import imagesLoaded from "imagesloaded";

const loadMoreResults = async (event) => {
    event.preventDefault();

    const link = event.target.closest('a.btn-more');
    const container = event.target.closest('.listing-container');
    const list = container.querySelector('ul');

    link.innerHTML = '<span class="loader">Wird geladen…</span>';

    // Load data
    const response = await axios.get(link.href);
    const template = document.createElement('template');
    template.innerHTML = response.data;

    // Append listing items
    const listingItems = template.content.querySelectorAll('.listing-item');
    listingItems.forEach(item => {
        list.appendChild(item);
        window.fadeInObserver.observe(item);
    });

    // Replace more results button
    const newLink = template.content.querySelector('a.btn-more');
    if (newLink) {
        link.replaceWith(newLink);

        newLink.addEventListener('click', loadMoreResults);
        window.fadeInObserver.observe(newLink);
    } else {
        link.remove();
    }
};

document.querySelectorAll('.listing-container a.btn-more').forEach(link => {
    link.addEventListener('click', loadMoreResults);
});
